import React from 'react'
import AddressSearchDialogContent from '../../routes/address/AddressSearchDialogContent'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import Main from '../main/Main'
import Map from '../map/Map'
import VdeMarkers from '../map/markers/VdeMarkers'
import SearchDialog from '../search/SearchDialog'
import AddressSuggestContent from '../suggest/AddressSuggestContent'
import AddressFullscreenMapHandler from './AddressFullscreenMapHandler'
import AddressHeaderForm from './AddressHeaderForm'
import AddressMainContent from './AddressMainContent'
import AddressMapImage from './AddressMapImage'
import { AddressVdeOnMapBanner } from './AddressVdeBanner'
import AddressMetaManager from './seo/AddressMetaManager'
import AddressPanoPreview from '../outdoor/AddressPanoPreview'
import { AdDesktopBannerAddressResult } from '../advertising/FloatingDesktopAdBanner'

export const renderPage = () => {
  const { AddressPage, withToaster } = PAGE_CLASSES

  return (
    <Page key="Page" cssClasses={[AddressPage, withToaster]}>
      <AddressMetaManager />
      <Map key="Map" staticMap={<AddressMapImage />}>
        <VdeMarkers />
        <AddressFullscreenMapHandler />
        <AddressVdeOnMapBanner />
        <AddressPanoPreview />
        <AdDesktopBannerAddressResult />
      </Map>
      <Header key="Header" transparent>
        <AddressHeaderForm key="AddressHeaderForm" transparent />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<AddressSuggestContent />}>
        <AddressSearchDialogContent />
      </SearchDialog>
      <Main key="Main" withoutSubHeader>
        <AddressMainContent />
      </Main>
    </Page>
  )
}
